var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-openindicator" }, [
    _c(
      "svg",
      {
        attrs: {
          width: "12",
          height: "7",
          viewBox: "0 0 12 7",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      [
        _c("path", {
          attrs: {
            d: "M5.30964 6.70905C4.92189 6.32111 4.92189 5.69215 5.30964 5.30421L10.305 0.306472C10.6928 -0.0814626 11.3214 -0.081462 11.7092 0.306473C12.0969 0.694408 12.0969 1.32337 11.7092 1.71131L6.71381 6.70905C6.32606 7.09698 5.69739 7.09698 5.30964 6.70905Z",
            fill: "#8E9CBB",
          },
        }),
        _c("path", {
          attrs: {
            d: "M6.70587 6.70905C7.09363 6.32111 7.09363 5.69215 6.70587 5.30421L1.69498 0.290951C1.30723 -0.096984 0.678565 -0.0969834 0.290814 0.290951C-0.0969378 0.678886 -0.0969378 1.30785 0.290814 1.69579L5.3017 6.70905C5.68946 7.09698 6.31812 7.09698 6.70587 6.70905Z",
            fill: "#8E9CBB",
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }